import React from 'react';
import { ChatSep } from './styled';

function ChatSeparator({timestamp}) {
  return timestamp ? (
    <ChatSep>
      <hr/>
    </ChatSep>
  ) : null
}

export default ChatSeparator;